import { motion, type HTMLMotionProps } from 'framer-motion';
import { cn } from '@/lib/utils';
import React from 'react';

interface AnimatedSectionProps extends HTMLMotionProps<'div'> {
  /** Delay in seconds before animation starts */
  delay?: number;
  /** Y-axis offset in pixels for entrance */
  offset?: number;
  children: React.ReactNode;
}

export function AnimatedSection({
  delay = 0,
  offset = 20,
  className,
  children,
  ...props
}: AnimatedSectionProps) {
  return (
    <motion.div
      initial={{ opacity: 0, y: offset }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true }}
      transition={{ duration: 0.5, delay, ease: [0.22, 1, 0.36, 1] }}
      className={cn(className)}
      {...props}
    >
      {children}
    </motion.div>
  );
}
